import { useEffect } from 'react';

import type { TrailerCheckDetailResponse } from '../models';
import { useTrailerCheckDetailStore } from './trailerCheckDetailStore';

type MutateCheck = () => Promise<TrailerCheckDetailResponse | undefined>;

export function useTrailerCheckDetailUi(checkId: string, mutate: MutateCheck) {
  const reset = useTrailerCheckDetailStore((s) => s.reset);

  useEffect(() => {
    reset();
  }, [checkId, reset]);

  const resolution = useTrailerCheckDetailStore((s) => s.resolution);
  const notes = useTrailerCheckDetailStore((s) => s.notes);
  const details = useTrailerCheckDetailStore((s) => s.details);

  const setResolutionNote = useTrailerCheckDetailStore((s) => s.setResolutionNote);
  const startResolutionEdit = useTrailerCheckDetailStore((s) => s.startResolutionEdit);
  const cancelResolutionEdit = useTrailerCheckDetailStore((s) => s.cancelResolutionEdit);
  const setEditedResolutionNote = useTrailerCheckDetailStore((s) => s.setEditedResolutionNote);
  const setNotesNewContent = useTrailerCheckDetailStore((s) => s.setNotesNewContent);
  const startNoteEdit = useTrailerCheckDetailStore((s) => s.startNoteEdit);
  const cancelNoteEdit = useTrailerCheckDetailStore((s) => s.cancelNoteEdit);
  const setEditedNoteContent = useTrailerCheckDetailStore((s) => s.setEditedNoteContent);
  const startDetailsEdit = useTrailerCheckDetailStore((s) => s.startDetailsEdit);
  const cancelDetailsEdit = useTrailerCheckDetailStore((s) => s.cancelDetailsEdit);
  const patchDetailsDraft = useTrailerCheckDetailStore((s) => s.patchDetailsDraft);

  const handleResolve = useTrailerCheckDetailStore((s) => s.handleResolve);
  const handleAddNote = useTrailerCheckDetailStore((s) => s.handleAddNote);
  const handleSaveResolution = useTrailerCheckDetailStore((s) => s.handleSaveResolution);
  const handleSaveNote = useTrailerCheckDetailStore((s) => s.handleSaveNote);
  const handleSaveDetails = useTrailerCheckDetailStore((s) => s.handleSaveDetails);

  return {
    resolution,
    notes,
    details,
    forms: {
      setResolutionNote,
      startResolutionEdit,
      cancelResolutionEdit,
      setEditedResolutionNote,
      setNotesNewContent,
      startNoteEdit,
      cancelNoteEdit,
      setEditedNoteContent,
      startDetailsEdit,
      cancelDetailsEdit,
      patchDetailsDraft,
    },
    actions: {
      handleResolve: () => handleResolve(checkId, mutate),
      handleAddNote: () => handleAddNote(checkId, mutate),
      handleSaveResolution: () => handleSaveResolution(checkId, mutate),
      handleSaveNote: (noteId: string) => handleSaveNote(checkId, noteId, mutate),
      handleSaveDetails: () => handleSaveDetails(checkId, mutate),
    },
  };
}

export type { TrailerCheckDetailUiState } from './trailerCheckDetailStore';
